import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import {Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit {
  //loginForm : FormGroup;
	submitted = false;
  hide=true;
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  data={};
  rdoUserTyp = new FormControl('');
  
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public auth: ApiService,
  ) { }
  loginForm = new FormGroup({
		email: new FormControl('', [Validators.required, Validators.email,
      Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
		password: new FormControl('', Validators.required),
	});

  ngOnInit() {
    this.rdoUserTyp.setValue("2");
  }
   // convenience getter for easy access to form fields
   get f() { return this.loginForm.controls; }
	
	loginUser(loginForm:any)
	{
		this.submitted = true;
    localStorage.removeItem('adminLoginPass');
		if(this.loginForm.invalid)
		{
			return;
		}
    var data1 = {'email': this.loginForm.value.email,'pass': this.loginForm.value.password};
    localStorage.setItem('adminLoginPass', JSON.stringify(data1));
    this.auth.admin_login(this.loginForm.value).subscribe(
      (data)=>{
        console.log(data);
      if(data.success){
        localStorage.setItem('adminData', JSON.stringify(data.data));
        if(data.data.user_mgmt_access == true){
         this.router.navigateByUrl('/user');
         return;  
        }
        if(data.data.course_mgmt_access == true){
          this.router.navigateByUrl('/courses');
          return;  
         }
         if(data.data.content_authoring_access == true){
          this.router.navigateByUrl('/authoring_list');
          return;  
         }
         if(data.data.organisation_mgmt_access == true){
          this.router.navigateByUrl('/organisation'); 
          return; 
         }
         if(data.data.reset_rqsts_access == true){
          this.router.navigateByUrl('/reset'); 
          return; 
         }
         if(data.data.backend_user_mgmt == true){
          this.router.navigateByUrl('/super-admin'); 
          return; 
         }
        //  if(data.data.settings_access == true){
        //   //this.router.navigateByUrl('/user'); 
        //return; 
        //  }
        //  if(data.data.reports_access == true){
        //   //this.router.navigateByUrl('/user');
        //return;  
        //  }
        
      }
      else if(data.error){
        
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = data.error;
      }else{
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = 'Incorrect email or password';
      }
      },
      (error) => { 
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = error;
       },
    );
	}
  goToForgot(){
    this.router.navigate(['/forgot'], { queryParams: { status: 2 } });
  }
}
